import { useCalendar } from '@/components/calendar/contexts/calendar-context';
import { getEventDayProgress } from '@/components/calendar/helpers';
import { format } from 'date-fns';

import { AgendaEventCard } from '@/components/calendar/components/agenda-view/agenda-event-card';

import type { IEvent } from '@/components/calendar/interfaces';

interface IProps {
  date: Date;
  events: IEvent[];
  multiDayEvents: IEvent[];
}

export function AgendaDayGroup({ date, events, multiDayEvents }: IProps) {
  const { timeZone } = useCalendar();
  const sortedEvents = [...events].sort(
    (a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
  );

  return (
    <div className="space-y-4">
      <div className="sticky top-0 flex items-center gap-4 bg-background py-2">
        <p className="text-sm font-semibold">
          {format(date, 'EEEE, MMMM d, yyyy')}
        </p>
      </div>

      <div className="space-y-2">
        {multiDayEvents.length > 0 &&
          multiDayEvents.map((event) => {
            const { eventTotalDays, eventCurrentDay } = getEventDayProgress(
              event,
              date,
              timeZone
            );

            return (
              <AgendaEventCard
                key={event.id}
                event={event}
                eventCurrentDay={eventCurrentDay}
                eventTotalDays={eventTotalDays}
              />
            );
          })}

        {sortedEvents.length > 0 &&
          sortedEvents.map((event) => (
            <AgendaEventCard key={event.id} event={event} />
          ))}
      </div>
    </div>
  );
}
